export default __webpack_public_path__ + "static/media/675c5de437bcb7aa.d23d02fe66b3f5d9d8a4ff82d439ae9a.svg";